import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import { BsWindowStack } from "react-icons/bs";
import { FaSave } from "react-icons/fa";
import { SiBookstack } from "react-icons/si";
import { GrDocument } from "react-icons/gr";
import { GiCrossMark } from "react-icons/gi";
import { AiFillPrinter } from "react-icons/ai";
import { TbWindowMaximize, TbWindowMinimize } from "react-icons/tb";
import AllPageNavbar from "../Components/AllPageNavbar";
import DashBoardNavbar from "../Components/DashBoardNavbar";
import HomePageNavbarFinancials from "../Components/HomePageNavbarFinancials";
import Loading from "../Components/Loading";
import { useDispatch, useSelector } from "react-redux";
const ItemAuxiliaryMaster = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const userState = useSelector((state) => state.changeTheState.user);
  const LoggedInUserName = userState?.emailId?.split("@")[0].toUpperCase();
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);

  const [areadId, setAreaId] = useState("");
  const [areaName, setAreaName] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [searchArea, setSearchArea] = useState("");

  const [itemsList, setItemsList] = useState([]);
  const [accompList, setAccompList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const [accompProductCode, setAccompProductCode] = useState("");
  const [accompProductName, setAccompProductName] = useState("");
  const [qty, setQty] = useState("");
  const [accompanimentRows, setAccompanimentRows] = useState([]);

  const filteredData = dataList?.filter((item) => {
    const searchData = searchArea?.toLowerCase()?.split(" ")?.filter(Boolean);
    const textMatch =
      searchData?.length === 0 ||
      searchData.every((term) => {
        return [
          "PARENTITEMCODE",
          "PARENTITEMNAME",
          "ACCOMPANIMENTITEMCODE",
          "ACCOMPANIMENTITEMNAME",
          "ACCOMPANIMENTQTY",
        ].some((key) => {
          const columnValue = String(item[key])?.toLowerCase();
          return columnValue?.includes(term);
        });
      });
    return textMatch;
  });

  useEffect(() => {
    masterData();
  }, []);

  function masterData() {
    setisloading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=287`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setItemsList(response?.data);
        const accompData = response?.data?.filter(
          (item) => item?.AUXILIARYITEM === true,
        );
        setAccompList(accompData);
      })
      .catch((error) => {
        console.error("Error fetching data 287:", error);
        setisloading(false);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1686`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setDataList(response?.data);
        setisloading(false);
      })
      .catch((error) => {
        console.error("Error fetching data 1686:", error);
        setisloading(false);
      });
  }


  function addAccompanimentRow() {
    if (!accompProductCode) {
      alert("Kindly Supply Auxiliary Product");
      return;
    }
    if (!qty) {
      alert("Kindly Supply Quantity");
      return;
    }

    // prevent duplicate accompaniment item for same product
    const alreadyExists = accompanimentRows.some(
      (row) => row.accompProductCode === accompProductCode,
    );
    if (alreadyExists) {
      alert("This Accompaniment Item is already added");
      return;
    }

    setAccompanimentRows((prev) => [
      ...prev,
      {
        accompProductCode,
        accompProductName,
        qty,
      },
    ]);

    // clear temp fields for next entry
    setAccompProductCode("");
    setAccompProductName("");
    setQty("");
  }

  function removeAccompanimentRow(index) {
    setAccompanimentRows((prev) => prev.filter((_, i) => i !== index));
  }




  async function submitCategory() {
    if (!productName) {
      alert("Kindly Supply Product");
      return;
    }

    // if (!accompProductCode) {
    //   alert("Kindly Supply Auxiliary Product");
    //   return;
    // }

    // if (!qty) {
    //   alert("Kindly Supply Quantity");
    //   return;
    // }

     if (accompanimentRows.length === 0) {
      alert("Kindly Add At Least One Auxiliary Item");
      return;
    }
      
    // try {
    //   const response = await axios.post(
    //     `${BASEURL_GLOBAL}/globalSpHandler?spname=1681`,
    //     {
    //       ITEMCODE: productCode,
    //       AUXILIARYITEM: accompProductCode,
    //       AUXILIARYITEMQTY: qty ? Number(qty) : 0,
    //     },
    //     {
    //       headers: {
    //         "auth-token": authToken,
    //         "session-token": sessiontoken,
    //       },
    //     },
    //   );

    //   if (response.status === 201) {
    //     alert(`Auxiliary Saved successfully`);
    //     window.location.reload();
    //   } else {
    //     alert(response?.data?.message);
    //     console.error(`Error while Saving Auxiliary`);
    //   }
    // } catch (error) {
    //   console.log(error);
    //   alert(error?.response?.data?.message);
    //   console.error(`Error while Saving Auxiliary`, error);
    // }

     try {
      const requests = accompanimentRows.map((row) =>
        axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1681`,
          {
            ITEMCODE: productCode,
            AUXILIARYITEM: row.accompProductCode,
            AUXILIARYITEMQTY: row.qty ? Number(row.qty) : 0,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        ),
      );

      const responses = await Promise.all(requests);

      const allSuccess = responses.every((response) => response.status === 201);

      if (allSuccess) {
        alert(`Auxiliary Saved successfully`);
        window.location.reload();
      } else {
        alert("Some Auxiliary failed to save");
        console.error("Error while Saving one or more Auxiliary");
      }
    } catch (error) {
      console.log(error);
      alert(error?.response?.data?.message);
      console.error(`Error while Saving Auxiliary`, error);
    }
  }
  if (isloading) {
    return <Loading />;
  }
  return (
    <div>
      {" "}
      <>
         <DashBoardNavbar />
              <HomePageNavbarFinancials/>
        <header className="header__of__main lg:flex  justify-between items-end px-3 ">
          <h1 className="header__of__page">ITEM AUXILIARY MASTER</h1>
          <div className="my-1">
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => {
                window.location.reload();
              }}
            >
              New
            </button>
            <button
              className=" bg-[#002d62]  text-white rounded-md px-2 h-[30px]  lg:ml-2 mr-2 "
              onClick={() => submitCategory()}
            >
              Save
            </button>
          </div>
        </header>
        <div>
          <article>
            <section className=" shadow-slate-100	m-2 bg-gray-100 border-black rounded	p-2 ">
              {/* <aside className="lg:flex lg:my-1 lg:mb-3">
                <p className="lg:ml-2">Product :</p>
                <Select
                  className="w-72 lg:ml-1"
                  onChange={(e) => {
                    setProductName(e.label);
                    setProductCode(e.value);
                  }}
                  value={
                    productName
                      ? {
                          label: productName,
                          value: productName,
                        }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...itemsList.map((item) => ({
                      value: item.OM_ITEM_CODE,
                      label: item.OM_ITEM_DESCRIPTION,
                    })),
                  ]}
                />
                <p className="lg:ml-2">Auxiliary Item :</p>
                <Select
                  className="w-72 lg:ml-1"
                  onChange={(e) => {
                    setAccompProductName(e.label);
                    setAccompProductCode(e.value);
                  }}
                  value={
                    accompProductName
                      ? {
                          label: accompProductName,
                          value: accompProductName,
                        }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...accompList.map((item) => ({
                      value: item.OM_ITEM_CODE,
                      label: item.OM_ITEM_DESCRIPTION,
                    })),
                  ]}
                />
                <p className="lg:ml-2">Quantity :</p>
                <input
                  className="lg:ml-2 w-20"
                  type="text"
                  value={qty}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only digits
                    if (/^\d*$/.test(value)) {
                      setQty(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    // Block "e", "E", "+", "-", ".", etc.
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                ></input>
              </aside> */}



              
                 <aside className="lg:flex lg:my-1 lg:mb-3">
                <p className="lg:ml-2">Product :</p>
                <Select
                  className="w-72 lg:ml-1"
                  onChange={(e) => {
                    setProductName(e.label);
                    setProductCode(e.value);
                  }}
                  value={
                    productName
                      ? { label: productName, value: productName }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...itemsList.map((item) => ({
                      value: item.OM_ITEM_CODE,
                      label: item.OM_ITEM_DESCRIPTION,
                    })),
                  ]}
                />
                <p className="lg:ml-2">Auxiliary Item :</p>
                <Select
                  className="w-72 lg:ml-1"
                  onChange={(e) => {
                    setAccompProductName(e.label);
                    setAccompProductCode(e.value);
                  }}
                  value={
                    accompProductName
                      ? { label: accompProductName, value: accompProductName }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...accompList.map((item) => ({
                      value: item.OM_ITEM_CODE,
                      label: item.OM_ITEM_DESCRIPTION,
                    })),
                  ]}
                />
                <p className="lg:ml-2">Quantity :</p>
                <input
                  className="lg:ml-2 w-20"
                  type="text"
                  value={qty}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setQty(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                ></input>

                <button
                  className="bg-[#002d62] text-white rounded-md px-3 h-[30px] lg:ml-3"
                  onClick={addAccompanimentRow}
                >
                  Add
                </button>
              </aside>

              
                 {/* --- LIST OF ADDED Auxiliary ROWS BEFORE SAVE --- */}
                            {accompanimentRows.length > 0 && (
                              <section className="table__pos__app w-[98%]  ">
                                <table className="custom-table">
                                  <thead className="header-cell">
                                    <tr>
                                      <td>S No</td>
                                      <td>Auxiliary Item Code</td>
                                      <td>Auxiliary Item Name</td>
                                      <td>Quantity</td>
                                      <td>Action</td>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {accompanimentRows.map((row, index) => (
                                      <tr key={index} className="table-row">
                                        <td className="text-right">{index + 1}</td>
                                        <td>{row.accompProductCode}</td>
                                        <td>{row.accompProductName}</td>
                                        <td className="text-right">{row.qty}</td>
                                        <td>
                                          <button
                                            className="text-red-600"
                                            onClick={() => removeAccompanimentRow(index)}
                                          >
                                            <AiOutlineClose />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </section>
                            )}


            </section>
          </article>
        </div>
        <section className="table__pos__app w-[98%]  ">
          <div className="lg:flex items-center">
            <p className="lg:mx-2 text-[16px]">Search</p>
            <input
              className="w-[200px] lg:mr-[50px]"
              required
              value={searchArea}
              onChange={(e) => {
                setSearchArea(e.target.value);
              }}
            ></input>
          </div>

          <table class="custom-table ">
            <thead class="header-cell">
              <tr>
                <td>S No</td>
                <td>Product Code</td>
                <td>Product Name</td>
                <td>Auxiliary Item Code</td>
                <td>Auxiliary Item Name</td>
                <td>Quantity</td>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                filteredData.map((value, index) => (
                  <tr
                    key={index}
                    className="table-row"
                    onClick={() => {
                      setProductCode(value?.PARENTITEMCODE);
                      setProductName(value?.PARENTITEMNAME);
                      setAccompProductCode(value?.ACCOMPANIMENTITEMCODE);
                      setAccompProductName(value?.ACCOMPANIMENTITEMNAME);
                      setQty(value?.ACCOMPANIMENTQTY);
                    }}
                  >
                    <td className="text-right">{index + 1}</td>
                    <td>
                      {value.PARENTITEMCODE ? value.PARENTITEMCODE : "N/A"}
                    </td>
                    <td>
                      {value.PARENTITEMNAME ? value.PARENTITEMNAME : "N/A"}
                    </td>
                    <td>
                      {value.ACCOMPANIMENTITEMCODE
                        ? value.ACCOMPANIMENTITEMCODE
                        : "N/A"}
                    </td>
                    <td>
                      {value.ACCOMPANIMENTITEMNAME
                        ? value.ACCOMPANIMENTITEMNAME
                        : "N/A"}
                    </td>
                    <td className="text-right">
                      {value.ACCOMPANIMENTQTY ? value.ACCOMPANIMENTQTY : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </>
    </div>
  );
};

export default ItemAuxiliaryMaster;
